// extracted by mini-css-extract-plugin
module.exports = {"Form":"Form_Form_Form__x3CEo","Submitted":"Form_Form_Submitted__jS9_J","Error":"Form_Form_Error__LlZtl","Recaptcha":"Form_Form_Recaptcha___DlEE"};